/** Memory-only handshake; cached consent never sets this state. */
export interface AccountReadiness {
  userId: string | null
  resolved: boolean
  identified: boolean
}
let state: AccountReadiness = { userId: null, resolved: false, identified: false }
const listeners = new Set<() => void>()
const sdkListeners = new Set<() => void>()
export function accountReadiness(): AccountReadiness {
  return state
}
export function updateAccountReadiness(next: AccountReadiness): void {
  state = next
  for (const listener of listeners) listener()
}
export function onAccountReadiness(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
export function notifyAnalyticsSdkReady(): void {
  for (const listener of sdkListeners) listener()
}
export function onAnalyticsSdkReady(listener: () => void): () => void {
  sdkListeners.add(listener)
  return () => {
    sdkListeners.delete(listener)
  }
}
